const plans = [
  {
    name: 'individual',
    monthlyPricing: 'R39',
    annualPricing: 'R348',
    amountSavedMonthly: 'R29',
    amountSavedYearly: 'R120',
    monthlyPlanCode: 'PLN_l6bg13aiqjr1yf7',
    annualPlanCode: 'PLN_p5f98eec11b6j9t',
    users: '1 User',
    features: [
      { name: 'Lifedocs secure vault' },
      { name: 'Phone and email support (9am-5pm)' },
      { name: '2 Factor Authentication' },
      {
        name: 'Bank-level security with AES 256-bit encryption',
        included: true
      },
      { name: '5GB vault storage space' }
    ]
  },
  {
    name: 'duo',
    monthlyPricing: 'R59',
    annualPricing: 'R588',
    amountSavedMonthly: 'R49',
    amountSavedYearly: 'R120',
    monthlyPlanCode: 'PLN_gos2b6v7gmzifbf',
    annualPlanCode: 'PLN_zkn1oa7kneon324',
    users: '2 Family users',
    features: [
      {
        name: 'Collaborate and keep each other’s documents up to date',
        included: true
      },
      { name: 'Lifedocs secure vault' },
      { name: 'Phone and email support (9am-5pm)' },
      { name: '2 Factor Authentication' },
      {
        name: 'Bank-level security with AES 256-bit encryption',
        included: true
      },
      { name: '10GB vault storage space' }
    ]
  },
  {
    name: 'family',
    monthlyPricing: 'R149',
    annualPricing: 'R1188',
    amountSavedMonthly: 'R99',
    amountSavedYearly: 'R600',
    monthlyPlanCode: 'PLN_yn2uv6rnoyt15xm',
    annualPlanCode: 'PLN_gxfo9d3a4et1k29',
    users: '6 Family users',
    features: [
      {
        name: 'Collaborate and keep each other’s documents up to date',
        included: true
      },
      { name: 'Lifedocs secure vault' },
      { name: 'Phone and email support (9am-5pm)' },
      { name: '2 Factor Authentication' },
      {
        name: 'Bank-level security with AES 256-bit encryption',
        included: true
      },
      { name: '30GB vault storage space' }
    ]
  }
];
export default plans;
